import React, { useState } from 'react';
import { Modal, Button, Radio } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { RadioChangeEvent } from 'antd';

interface VisibilityModalProps {
  visible: boolean;
  isPrivate: boolean;
  onConfirm: (status: boolean) => void;
  onCancel: () => void;
  loading?: boolean;
}

const VisibilityModal: React.FC<VisibilityModalProps> = ({
  visible,
  isPrivate,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const [visibilityStatus, setVisibilityStatus] = useState<boolean>(isPrivate);

  const handleVisibilityChange = (e: RadioChangeEvent) => {
    setVisibilityStatus(e.target.value as boolean);
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
      className={styles.visibilityModal}>
      <div className={styles.modalContent}>
        <div className={styles.icon}>
          <ExclamationCircleOutlined />
        </div>
        <h3 className={styles.title}>Confirm Visibility Change</h3>
        <p className={styles.message}>
          {!visibilityStatus
            ? 'Are you sure you want to make this story public? This story will appear in the Tadatoon Library.'
            : 'This story will be removed from the Tadatoon Library and will no longer be visible to other users. Are you sure?'}
        </p>

        <div className={styles.visibilityOptions}>
          <Radio.Group
            value={visibilityStatus}
            onChange={handleVisibilityChange}>
            <Radio value={true}>Private</Radio>
            <Radio value={false}>Public</Radio>
          </Radio.Group>
        </div>
        <div className={styles.actions}>
          <Button
            type="primary"
            onClick={() => onConfirm(visibilityStatus)}
            loading={loading}
            className={styles.confirmButton}>
            Confirm
          </Button>
          <Button
            onClick={onCancel}
            disabled={loading}
            className={styles.cancelButton}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VisibilityModal;
